import { Controller } from '@hotwired/stimulus';
import { ListState } from './list_state'
import { SearchBarManager } from './search_bar_manager'

export default class extends Controller {
  static targets = [
    "availableListSelectedItemsInput",
    "assignedListSelectedItemsInput",
    "selectAllButton",
    "availableList",
    "assignedList",
    "selectAllButtonAvailable",
    "selectAllButtonAssigned",
    "moveButtonAvailable",
    "moveButtonAssigned",
    "itemsSelectedTextAvailable",
    "itemsSelectedTextAssigned",
    "availableSearchBar",
    "assignedSearchBar",
    "availableClearButton",
    "assignedClearButton"
  ];

  private availableListState: ListState;
  private assignedListState: ListState;
  private availableSearchManager: SearchBarManager;
  private assignedSearchManager: SearchBarManager;

  connect(): void {
    this.initializeStates();
    this.initializeSearchManagers();
  }

  private initializeStates(): void {
    this.availableListState = new ListState(
      this.availableListTarget,
      this.itemsSelectedTextAvailableTarget,
      this.selectAllButtonAvailableTarget,
      this.moveButtonAvailableTarget
    );

    this.assignedListState = new ListState(
      this.assignedListTarget,
      this.itemsSelectedTextAssignedTarget,
      this.selectAllButtonAssignedTarget,
      this.moveButtonAssignedTarget
    );
  }

  private initializeSearchManagers(): void {
    this.availableSearchManager = new SearchBarManager(
      this.availableSearchBarTarget,
      this.availableClearButtonTarget
    );

    this.assignedSearchManager = new SearchBarManager(
      this.assignedSearchBarTarget,
      this.assignedClearButtonTarget
    );
  }

  onMoveButtonClick(event: Event): void {
    const moveDirection = (event.currentTarget as HTMLElement).dataset.movedirection;
    if (moveDirection === 'available') {
      this.availableListState.clearSelection();
    } else {
      this.assignedListState.clearSelection();
    }
    this.updateHiddenFields();
  }

  onItemClick(event: Event): void {
    const item = event.currentTarget as ListItem;
    const { value, list } = item.dataset;
    const state = list === 'available' ? this.availableListState : this.assignedListState;

    if (state.isItemSelected(value)) {
      item.classList.remove('selected');
      state.unselectItem(value);
    } else {
      item.classList.add('selected');
      state.selectItem(value);
    }

    this.updateHiddenFields();
  }

  onSelectAllButtonClick(event: Event): void {
    const item = event.currentTarget as ListItem;
    const { value, list } = item.dataset;
    const state = list === 'available' ? this.availableListState : this.assignedListState;

    if (state.areAllItemsSelected()) {
      state.unselectAllItems();
    } else {
      state.selectAllItems();
    }

    this.updateHiddenFields();
  }

  private updateHiddenFields(): void {
    this.availableListSelectedItemsInputTarget.value = this.availableListState.getSelectedItems().join(',');
    this.assignedListSelectedItemsInputTarget.value = this.assignedListState.getSelectedItems().join(',');
  }
}
